module.exports = __webpack_public_path__ + "static/img/funny_03.2addecd2.jpg";